import Model from "./model";
import Offer from "../api/model/users/Offer";

// TODO: Revisit after Zeplin.user and barrel user interfaces are separated
interface UserData {
    _id: string;
    paymentPlan?: string;
    email?: string;
    status?: string;
    username?: string | null;
    fullName?: string | null;
    bio?: string | null;
    subscriptionStatus?: string;
    subscriptionCancelAtPeriodEnd?: boolean;
    subscriptionCancelAt?: string;
    emotar?: string | null;
    avatar?: string | null;
    lastSeen?: string;
    offers?: Offer[];
}

class User extends Model {
    id: string;
    _id: string;
    paymentPlan?: string;
    email?: string;
    status?: string;
    username?: string | null;
    fullName?: string | null;
    bio?: string | null;
    subscriptionStatus?: string;
    subscriptionCancelAtPeriodEnd?: boolean;
    subscriptionCancelAt?: string;
    emotar?: string | null;
    avatar?: string | null;
    lastSeen?: string;
    offers?: Offer[];

    constructor(userDetailsData: UserData) {
        super();

        const {
            _id,
            paymentPlan,
            email,
            status,
            username,
            fullName,
            bio,
            subscriptionStatus,
            subscriptionCancelAtPeriodEnd,
            subscriptionCancelAt,
            emotar,
            avatar,
            lastSeen,
            offers
        } = userDetailsData;

        this.id = _id;
        this._id = _id;
        this.paymentPlan = paymentPlan;
        this.email = email;
        this.status = status;
        this.username = username;
        this.fullName = fullName;
        this.bio = bio;
        this.subscriptionStatus = subscriptionStatus;
        this.subscriptionCancelAtPeriodEnd = subscriptionCancelAtPeriodEnd;
        this.subscriptionCancelAt = subscriptionCancelAt;
        this.emotar = emotar;
        this.avatar = avatar;
        this.lastSeen = lastSeen;
        this.offers = offers;
    }
}

export default User;
export {
    UserData
};
